import { createContext } from 'react';

const ConfigurationsContext = createContext(null);

export default ConfigurationsContext;
